import TableSection from './TableSection'

export default TableSection